var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _this = this;
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import cloneDeep from 'lodash/cloneDeep';
import { sendToHost } from 'conversional-iframe-communication';
import { ConfigActions, ContentApis, Events, TrackingActions, useAppDispatch, } from 'conversional-journey';
import { addCallbacks } from 'conversional-callbacks';
import { createComponentsFromObject } from 'conversional-components';
import { DYNAMIC_DEFAULT } from './Dynamic.styles';
import { onEsc } from '../utils/listener';
import Fullscreen from '../components/Fullscreen';
/**
 * Entry View
 * Toggles view/hide of the entry point
 * Usually renders it in Fullscreen mode
 */
var Dynamic = function (_a) {
    var contentParams = _a.contentParams, onApplyStyles = _a.onApplyStyles, token = _a.token;
    var dispatch = useAppDispatch();
    var trackEvent = function (event) { return dispatch(TrackingActions.event(event)); };
    var data = ContentApis.useLoadContentQuery({
        contentType: token,
        contentParams: contentParams,
    }).data;
    var content = get(data, 'content', null);
    var Window = get(content, 'Window', {});
    var closable = get(Window, 'closable', true);
    var getModalProps = function () {
        var props = cloneDeep(get(Window, 'modalProps', {}));
        props.hideResetButton = true;
        if (typeof props.hideCloseButton !== 'boolean')
            props.hideCloseButton = !closable;
        return props;
    };
    var onClose = function () {
        if (!closable)
            return;
        trackEvent(__assign(__assign({}, Events.DYNAMIC_CONTENT_HIDDEN), { label: token }));
        sendToHost.destroy();
    };
    React.useEffect(function () {
        sendToHost.styleIframe(DYNAMIC_DEFAULT);
        onApplyStyles();
        /**
         * Current usecases:
         * 1. store resultId for standalone appointment booking
         * */
        dispatch(ConfigActions.setExternal({ data: contentParams }));
        window.conversionalContext = token;
        trackEvent(__assign(__assign({}, Events.DYNAMIC_CONTENT_SHOWN), { label: token }));
    }, []);
    React.useEffect(function () {
        if (!content)
            return;
        var iframeStyles = Window === null || Window === void 0 ? void 0 : Window.iframeStyles;
        if (iframeStyles) {
            sendToHost.styleIframe(iframeStyles, true);
        }
        var callbacks = get(content, 'Window.callbacks', null);
        var supportedCallbacks = {};
        if (closable) {
            onEsc(onClose);
        }
        supportedCallbacks.closeCallback = sendToHost.destroy;
        addCallbacks(_this, callbacks, supportedCallbacks);
    }, [Window]);
    if (isEmpty(content))
        return null;
    return (_jsx(Fullscreen, { onClose: onClose, modalProps: getModalProps(), children: _jsx(_Fragment, { children: content && createComponentsFromObject({ root: content || {} }) }) }));
};
// @ts-ignore
export default Dynamic;
